// extracted by mini-css-extract-plugin
export default {"root":"FooterLogo_root__hIHP-","logo":"FooterLogo_logo__-Q+5F","logo24":"FooterLogo_logo24__qCUOp","logo36":"FooterLogo_logo36__MXwPI","logo48":"FooterLogo_logo48__2Z+fx"};